import React, { FC } from 'react';
import { useUserOptions } from 'components/organisms/tasks/criteria/use-user-options';
import { MultiUserFieldFilter } from 'components/organisms/tasks/filters/multi-user';
import { MultiSelectBaseFilterToText } from './multi-select-base-filter';

export const MultiUserFilterToText: FC<{
  filter: MultiUserFieldFilter;
}> = ({ filter }) => {
  const options = useUserOptions(filter.field.metaData.users);

  return <MultiSelectBaseFilterToText filter={filter} options={options} />;
};
